<template>
  <div>
    <PageHeaderLayout>
      <div style="background: #fff; padding: 20px 20px">
        <el-table :data="feetbackData" style="width: 100%">
          <el-table-column
            prop="userInfo.nickName"
            label="微信昵称"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="content" label="反馈内容" align="center">
          </el-table-column>
          <el-table-column prop="created_at" label="反馈时间" align="center">
          </el-table-column>
        </el-table>
      </div>

      <div class="box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagege.current_page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagege.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagege.total"
        >
        </el-pagination>
      </div>
    </PageHeaderLayout>
  </div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      ispage: 1,
      num: 10,
      feetbackData: [],
      pagege: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let params = {
        current_page: this.ispage,
        page_size: this.num,
      };
      let { data, pages } = await this.$api.feetbackUrl(params);
      this.feetbackData = data;
      this.pagege = pages;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.num = val;
      this.ispage = 1;
      this.init();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.ispage = val;
      this.init();
    },
  },
};
</script>
<style scoped>
.el-pagination {
  margin-top: none;
  padding: 0 20px 20px 0;
  display: flex;
  justify-content: flex-end;
}
.is-background {
  margin-top: 0 !important;
}
.box {
  background: #fff;
  width: 100%;
}
</style>
